const UserStore = {
  logged: false
}

export default UserStore



// WEBPACK FOOTER //
// ./src/store/user-store.js